import { jsxs as d, jsx as e } from "react/jsx-runtime";
import { t as g, d as h, U as x } from "../../vendor-Dd6qj6gJ.js";
import { IconButton as m } from "../IconButton/index.js";
import { c as i } from "../../styles.module-BF2N4g8-.js";
import { useTableContext as u } from "./tableContext.js";
function M({ pageIndex: o, pageSize: s, totalCount: r }) {
  const c = x(), n = Math.max(0, Math.trunc(o)), t = Math.max(1, Math.trunc(s)), a = Math.max(0, Math.trunc(r)), b = a === 0 ? 0 : Math.max(0, Math.ceil(a / t) - 1), l = Math.min(n, b), f = a === 0 ? 0 : l * t + 1, p = Math.min(a, (l + 1) * t);
  return /* @__PURE__ */ e("span", { className: i.paginationRange, "aria-live": "polite", children: `${f}-${p} of ${c.format(a)}` });
}
function v({
  hasPreviousPage: o,
  hasNextPage: s,
  onPrevious: r,
  onNext: c,
  range: n,
  ...t
}) {
  const { isLoading: a } = u();
  return /* @__PURE__ */ d("nav", { className: i.pagination, "aria-label": t["aria-label"], children: [
    n ? /* @__PURE__ */ e(M, { ...n }) : null,
    /* @__PURE__ */ d(g, { className: h(i.paginationContent, a && i.paginationLoading), children: [
      /* @__PURE__ */ e(
        m,
        {
          size: "sm",
          variant: "ghost",
          icon: "chevron-back",
          onPress: () => {
            a || r();
          },
          "aria-disabled": a || void 0,
          isDisabled: !o,
          "aria-label": "Previous page"
        }
      ),
      /* @__PURE__ */ e(
        m,
        {
          size: "sm",
          variant: "ghost",
          icon: "chevron-next",
          onPress: () => {
            a || c();
          },
          "aria-disabled": a || void 0,
          isDisabled: !s,
          "aria-label": "Next page"
        }
      )
    ] })
  ] });
}
v.displayName = "Table.Pagination";
export {
  v as Pagination
};
